import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { InsuranceService } from '../../../../../services/insurance.service';
import { MenuItem } from 'primeng/api';
import { Claim } from '../../models/claim.models';
import { MessageService } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import { HelpersService } from '../../../../../services/helpers.service';
import { Bike, BikeComponent, Note } from '../../models/claim.models';

interface ConfiguredTask {
  ID: number;
  Name: string;
}

@Component({
  selector: 'app-claim-info',
  templateUrl: './claim-info.component.html',
  styleUrls: ['./claim-info.component.scss', '../../css/_shared.scss'],
  providers: [MessageService],
  encapsulation: ViewEncapsulation.None,
})
export class ClaimInfoComponent implements OnInit {
  public employees: SelectItem[] = [];
  public selectedEmployee: any;
  public selectedTaskEmployee: any;

  public navigationItems: any = [];
  public statuses: SelectItem[] = [];
  public selectedStatus: any;
  public columns: any = [];
  public claims: any = [];
  public showClaim: boolean = false;
  public tabMenuItems: any[] = [];
  public selectedTabMenuItem: any;

  public activeItem: MenuItem;
  claimObject: Claim;

  bikes: string[] = [];
  components: string[] = [];
  bikeSelectList: SelectItem[] = [];
  bikeSelected: Bike;

  configuredTasks: SelectItem[];
  selectedConfiguredTasks: ConfiguredTask;

  public showTasks: boolean = true;
  public showClaims: boolean = false;
  public showAttachments: boolean = false;
  public showQuotes: boolean = false;
  public showMessages: boolean = false;
  public showProcurement: boolean = false;

  public dueDate: Date;
  public note: string = '';
  public allNotes: any[] = [];

  excess: number = 0;
  sumInsured: number = 0;

  images: any[] = [];
  incidentTypes: SelectItem[];
  selectedIncidentType: any;
  uploadedFiles: any[] = [];

  saving: boolean = false;

  constructor(
    public insuranceService: InsuranceService,
    public messageService: MessageService,
    public helpersService: HelpersService,
  ) {}

  ngOnInit() {
    this.claimObject = new Claim(
      0,
      0,
      '',
      '',
      0,
      '',
      0,
      '',
      0,
      0,
      '',
      0,
      0,
      new Date(),
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      [],
      [],
      '',
      '',
    );
    console.log(this.claimObject);

    this.tabMenuItems = [
      {
        ID: 1,
        title: 'Claim',
        backgroundImage:
          'https://cdn3.iconfinder.com/data/icons/contact-us-set-1/256/64-512.png',
      },
      {
        ID: 2,
        title: 'Attachments',
        backgroundImage:
          'https://cdn3.iconfinder.com/data/icons/contact-us-set-1/256/62-512.png',
      },
    ];

    this.incidentTypes = [
      { label: 'Select Incident Type', value: null },
      { label: 'Accidental damage', value: { label: 'Accidental damage' } },
      { label: 'Theft from home', value: { label: 'Theft from home' } },
      {
        label: 'Theft away from home',
        value: { label: 'Theft away from home' },
      },
    ];

    this.selectedTabMenuItem = this.tabMenuItems[0];
    this.showClaims = true;
    var clmID = window.location.href.substring(
      window.location.href.lastIndexOf('/') + 1,
    );
    this.displayClaim(clmID);
  }

  public displayClaim(claimID) {
    this.selectedTabMenuItem = this.tabMenuItems[0];

    this.claimObject = new Claim(
      0,
      0,
      '',
      '',
      0,
      '',
      0,
      '',
      0,
      0,
      '',
      0,
      0,
      new Date(),
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      [],
      [],
      '',
      '',
    );
    this.bikes = [];
    this.bikeSelectList = [];
    this.allNotes = [];
    this.images = [];

    console.log(claimID);
    this.showClaims = true;
    try {
      this.insuranceService.getClaim(claimID).subscribe((response) => {
        if (response !== '') {
          var obj = JSON.parse(response);
          console.log(obj);
          for (var i = 0; i < obj.Claims.length; i++) {
            this.claimObject = obj.Claims[i];
          }
          console.log('Claim Object');
          console.log(this.claimObject);
          for (var i = 0; i < this.claimObject.Bikes.length; i++) {
            this.bikes.push(this.claimObject.Bikes[i].Name);
            this.bikeSelectList.push({
              label: this.claimObject.Bikes[i].Name,
              value: this.claimObject.Bikes[i].Name,
            });
          }
          for (var i = 0; i < this.claimObject.Notes.length; i++) {
            this.allNotes.push(this.claimObject.Notes[i]);
          }

          for (var i = 0; i < this.allNotes.length; i++) {
            if (this.allNotes[i].Completed === false)
              this.allNotes[i].DueDate = new Date(this.allNotes[i].DueDate);
          }

          for (var i = 0; i < this.statuses.length; i++) {
            if (this.statuses[i].label == this.claimObject.Status)
              this.selectedStatus = this.statuses[i];
          }

          for (var i = 0; i < this.claimObject.Attachments.length; i++) {
            if (this.claimObject.Attachments[i].FileType.startsWith('image'))
              this.images.push({
                source: this.claimObject.Attachments[i].FileURL,
                alt: '',
                title: this.claimObject.Attachments[i].FileName,
              }); // = this.statuses[i];
          }

          for (var i = 0; i < this.incidentTypes.length; i++) {
            if (this.incidentTypes[i].label == this.claimObject.IncidentType)
              this.selectedIncidentType = this.incidentTypes[i];
          }
          this.claimObject.IncidentDate = new Date(
            this.claimObject.IncidentDate,
          );

          for (var i = 0; i < this.incidentTypes.length; i++) {
            if (this.incidentTypes[i].label == this.claimObject.IncidentType) {
              this.incidentTypes = [
                {
                  label: this.incidentTypes[i].label,
                  value: { label: this.incidentTypes[i].label },
                },
                { label: 'Select New Incident Type', value: null },
                {
                  label: 'Accidental damage',
                  value: { label: 'Accidental damage' },
                },
                {
                  label: 'Theft from home',
                  value: { label: 'Theft from home' },
                },
                {
                  label: 'Theft away from home',
                  value: { label: 'Theft away from home' },
                },
              ];

              this.selectedIncidentType = this.incidentTypes[0];
            }
          }

          if (this.bikeSelectList.length > 0) {
            this.bikeSelected = this.bikeSelectList[0].value;
            this.showComponents();
          }
        }
        console.log(this.allNotes);
      });
    } catch (e) {
      console.log(e);
    }
  }

  minimizeAndSaveClaim() {
    this.saving = true;
    this.showClaim = false;
    if (this.claimObject.Notes == undefined) this.claimObject.Notes = [];

    console.log(JSON.stringify(this.claimObject));

    if (this.claimObject.Notes == undefined) this.claimObject.Notes = [];

    for (var i = 0; i < this.allNotes.length; i++) {
      this.claimObject.Notes.push({
        ID: this.allNotes[i].ID,
        ClaimID: this.allNotes[i].ClaimID,
        DueDate: this.allNotes[i].DueDate,
        Description: this.allNotes[i].Description,
        Completed: this.allNotes[i].Completed,
        Assignee: this.allNotes[i].Assignee,
        AssigneeID: this.allNotes[i].AssigneeID,
        IsStandardTask: this.allNotes[i].IsStandardTask,
      });
    }

    this.saveClaim();
  }

  saveClaim() {
    var count = 0;
    var arrC = 0;
    for (var i = 0; i < this.uploadedFiles.length; i++) {
      var reader = new FileReader();
      reader.readAsDataURL(this.uploadedFiles[i]);
      reader.onload = (file: any) => {
        let data = {
          ID: 0,
          ClaimID: 0,
          FileType: this.uploadedFiles[arrC].type,
          FileName: this.uploadedFiles[arrC].name,
          FileURL: '',
          FileData: file.target.result.split(',')[1],
        };

        if (this.claimObject.Attachments.indexOf(data) === -1)
          this.claimObject.Attachments.push(data);

        count += 1;
        arrC += 1;

        if (count == this.uploadedFiles.length) {
          this.insuranceService
            .saveClaim(this.claimObject)
            .subscribe((response) => {
              this.messageService.add({
                life: 5000,
                summary: 'Claim saved',
                detail:
                  'Claim has been saved. Continue editing the claim or create a new one',
              });
              var clmID = window.location.href.substring(
                window.location.href.lastIndexOf('/') + 1,
              );
              this.displayClaim(clmID);
              this.saving = false;
            });
        }
      };
    }
    if (this.uploadedFiles.length == 0)
      this.insuranceService
        .saveClaim(this.claimObject)
        .subscribe((response) => {
          this.messageService.add({
            life: 5000,
            summary: 'Claim saved',
            detail:
              'Claim has been saved. Continue editing the claim or create a new one',
          });
          var clmID = window.location.href.substring(
            window.location.href.lastIndexOf('/') + 1,
          );
          this.displayClaim(clmID);
          this.saving = false;
        });
  }

  showPage(id) {
    this.showTasks = false;
    this.showClaims = false;
    this.showAttachments = false;
    this.showQuotes = false;
    this.showMessages = false;
    this.showProcurement = false;

    if (id === 1) this.showClaims = true;
    if (id === 2) this.showAttachments = true;
  }

  addBike(event) {
    this.bikeSelectList.push({ label: event.value, value: event.value });
    this.claimObject.Bikes.push({
      ID: 0,
      Name: event.value,
      Components: [],
      Excess: 0,
      SumInsured: 0,
    });
    console.log(event);
  }

  addComponentToBike(event) {
    console.log(this.bikeSelected);
    for (var i = 0; i < this.claimObject.Bikes.length; i++) {
      if (this.claimObject.Bikes[i].Name === this.bikeSelected.toString()) {
        if (this.claimObject.Bikes[i].Components == undefined)
          this.claimObject.Bikes[i].Components = [];
        this.claimObject.Bikes[i].Components.push({
          ID: 0,
          Description: event.value,
        });
      }
    }
  }

  removeBike(event) {
    for (var i = 0; i < this.bikeSelectList.length; i++) {
      if (this.bikeSelectList[i].label === event.value) {
        this.bikeSelectList.splice(i, 1);
        i--;
      }
    }

    for (var i = 0; i < this.claimObject.Bikes.length; i++) {
      if (this.claimObject.Bikes[i].Name === event.value) {
        this.claimObject.Bikes.splice(i, 1);
        i--;
      }
    }
    console.log(this.bikeSelectList);
  }

  removeComponentToBike(event) {
    for (var i = 0; i < this.claimObject.Bikes.length; i++) {
      if (this.claimObject.Bikes[i].Name === this.bikeSelected.toString()) {
        for (var x = 0; x < this.claimObject.Bikes[i].Components.length; x++) {
          if (this.claimObject.Bikes[i].Components[x] === event.value) {
            this.claimObject.Bikes[i].Components.splice(x, 1);
            x--;
          }
        }
      }
    }
  }

  showComponents() {
    console.log(this.bikeSelected);
    this.components = [];
    for (var i = 0; i < this.claimObject.Bikes.length; i++) {
      if (this.claimObject.Bikes[i].Name === this.bikeSelected.toString()) {
        for (var x = 0; x < this.claimObject.Bikes[i].Components.length; x++) {
          this.components.push(
            this.claimObject.Bikes[i].Components[x].Description,
          );
        }
        this.excess = this.claimObject.Bikes[i].Excess;
        this.sumInsured = this.claimObject.Bikes[i].SumInsured;
      }
    }
  }

  onUpload(event) {
    var cont = true;
    console.log(event);
    for (let file of event.files) {
      if (this.uploadedFiles.indexOf(file) === -1)
        this.uploadedFiles.push(file);
    }
    console.log(this.uploadedFiles);
  }

  onRemove(event) {
    console.log(event);
    this.uploadedFiles.splice(this.uploadedFiles.indexOf(event.file), 1);
  }
}
